import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import VehicleHistoryComponent from '../work-orders/VehicleHistory';

const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const History = ({
  plate,
  open,
  handleHistoryDialog,
  ...props
}) => {

  const classes = useStyles();
  return (
		<Dialog fullScreen open={open} onClose={(e) => {handleHistoryDialog(e,'')}} >
			<AppBar className="mt-2" >
			  <Toolbar>
			    <IconButton edge="start" color="inherit" onClick={(e) => {handleHistoryDialog(e,'')}} aria-label="close">
			      <CloseIcon />
			    </IconButton>
			    <Typography variant="h6" className={classes.title} style={{color:"white"}}>
			      Historial de {plate}
			    </Typography>
			  </Toolbar>
			</AppBar>
			<VehicleHistoryComponent plate={plate}/>
		</Dialog>
	)

}
export default History;
